import i from"styled-components";var o=i("div").withConfig({componentId:"sc-1ep6kh8-0"})(["position:relative;display:inline-flex;"]);export{o as Wrapper};
